/**
 * Kimlik doğrulama şemaları — API ve ARAYÜZ AYNI TANIMI KULLANIR [K-020].
 *
 * ═══════════════════════════════════════════════════════════════════════════
 * NEDEN PAYLAŞILIYOR
 *
 * Doğrulama iki yerde yazılırsa SESSİZCE AYRIŞIR. En tehlikeli hâli şudur:
 * istemci kabul eder, sunucu reddeder — kullanıcı "Kaydet"e basar, formu
 * doldurduğunu sanır, sonra anlamadığı bir hata alır. Tersi de olur:
 * istemci reddeder ama sunucu kabul ederdi; kullanıcı yapabileceği bir şeyi
 * yapamaz.
 *
 * Tek tanım bu sınıfı imkânsız kılar. "Oluşturma kolay olsun" isteğinin
 * teknik karşılığı budur: kullanıcı ne yazabileceğini ANINDA ve DOĞRU öğrenir.
 * ═══════════════════════════════════════════════════════════════════════════
 */
import { z } from 'zod';
/**
 * Giriş formu.
 *
 * Sınırlar keyfi değil: e-posta 320 karakter (RFC 5321'in yerel+alan üst
 * sınırı), parola 1024 (argon2id girdisi sınırsız olabilir ama gövde şişmesini
 * engelliyoruz), TOTP 16 (6 hane + olası boşluk/tire biçimlendirmesi).
 */
export const loginSchema = z.object({
    email: z
        .string()
        .min(1, 'E-posta gerekli.')
        .max(320, 'E-posta çok uzun.')
        // Sunucu tarafı da `citext` ile büyük/küçük harf duyarsız — burada
        // biçim kontrolü yapıyoruz, kimlik doğrulaması değil.
        .email('Geçerli bir e-posta adresi girin.'),
    password: z.string().min(1, 'Parola gerekli.').max(1024, 'Parola çok uzun.'),
    /**
     * TOTP OPSİYONEL [K-009] — yalnız kurmuş kullanıcıdan istenir.
     * Boş dize `undefined` sayılır: kullanıcı alanı görüp boş bırakabilir.
     */
    totpCode: z
        .string()
        .max(16, 'Doğrulama kodu çok uzun.')
        .optional()
        .transform((v) => (v === '' ? undefined : v)),
});
/** Parola değiştirme — asgari uzunluk sunucudaki kuralla AYNI (12). */
export const passwordChangeSchema = z.object({
    currentPassword: z.string().min(1, 'Mevcut parola gerekli.'),
    newPassword: z
        .string()
        .min(12, 'Yeni parola en az 12 karakter olmalı.')
        .max(1024, 'Parola çok uzun.'),
});
/** Operatörün etkin firma seçimi. `null` = seçimi kaldır (tüm firmalar). */
export const activeFirmSchema = z.object({
    firmId: z.number().int().positive().nullable(),
});
//# sourceMappingURL=auth.js.map